import moment from 'moment';

// BaseResponse<T> is { isSuccessful, message, result } (confirmed against the
// RELEASE_UNIT_BLOCKING wrapper elsewhere in this app). GET calls sometimes
// omit isSuccessful on a plain 200, so a missing flag is treated as success.
export const isApiSuccess = (data) => data?.isSuccessful !== false;

export const unwrapApiError = (data) => data?.message || 'Something went wrong. Please try again.';

// GetMultipleDropdown doesn't always key its response under the exact type
// name requested (seen before on Unit Block) - prefer the expected key, fall
// back to the first non-empty array so the dropdown doesn't silently stay empty.
export const extractDropdownArray = (dropdowns, preferredKey) => {
  if (!dropdowns) return [];
  if (Array.isArray(dropdowns[preferredKey])) return dropdowns[preferredKey];
  const firstArray = Object.values(dropdowns).find((v) => Array.isArray(v) && v.length);
  return firstArray || [];
};

export const toOption = (item) => ({ value: item?.value, label: item?.text ?? item?.label ?? '' });

export const formatDateForApi = (date) => (date ? moment(date).format('YYYY-MM-DD') : '');

export const RELEASE_TYPE_BADGE = {
  Release: { background: '#E3F2FD', color: '#1565C0' },
  Cancelled: { background: '#EEEEEE', color: '#616161' },
  'Lease Release': { background: '#FFF3E0', color: '#E65100' },
  'Lease Expiry Checkout': { background: '#F3E5F5', color: '#6A1B9A' },
  'Payment Schedule': { background: '#E0F2F1', color: '#00695C' },
};

export const getReleaseTypeBadgeStyle = (releaseType) => RELEASE_TYPE_BADGE[releaseType] || { background: '#EEEEEE', color: '#616161' };

export const getStatusBadgeStyle = (status) =>
  String(status || '').trim().toLowerCase() === 'available' ? { background: '#E8F5E9', color: '#2E7D32' } : { background: '#EEEEEE', color: '#424242' };

// A candidate/selected row is the same unit as one already in the list when
// property + unit + unit ref no all match, case-insensitively.
export const isDuplicate = (row, list) => {
  const key = (r) => `${String(r?.propertyNo ?? '').trim().toLowerCase()}||${String(r?.unitNo ?? '').trim().toLowerCase()}||${String(r?.unitRefNo ?? '').trim().toLowerCase()}`;
  const rowKey = key(row);
  return (list || []).some((r) => key(r) === rowKey);
};

// Appends candidates returned by GetCandidates to the selected-units grid,
// skipping ones already present and ticking everything except hasReceipt rows
// (those can never be released, so they're added but left unticked).
export const mergeCandidates = (list, candidates) => {
  const next = [...(list || [])];
  (candidates || []).forEach((candidate) => {
    if (isDuplicate(candidate, next)) return;
    next.push({ ...candidate, selected: !candidate.hasReceipt });
  });
  return next;
};
